import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.0002 4.66634C10.7785 4.66634 8.16683 7.27801 8.16683 10.4997C8.16683 13.7213 10.7785 16.333 14.0002 16.333C17.2218 16.333 19.8335 13.7213 19.8335 10.4997C19.8335 7.27801 17.2218 4.66634 14.0002 4.66634ZM5.8335 10.4997C5.8335 5.98935 9.48984 2.33301 14.0002 2.33301C18.5105 2.33301 22.1668 5.98935 22.1668 10.4997C22.1668 15.01 18.5105 18.6663 14.0002 18.6663C9.48984 18.6663 5.8335 15.01 5.8335 10.4997Z",
      fill: "#0A072D"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.0002 18.6663C12.0545 18.6663 10.143 19.1783 8.45782 20.1509C6.77263 21.1236 5.37306 22.5225 4.39971 24.2073C4.07738 24.7652 3.36381 24.9562 2.80589 24.6338C2.24798 24.3115 2.057 23.5979 2.37932 23.04C3.55751 21.0007 5.25162 19.3073 7.29146 18.13C9.3313 16.9527 11.645 16.333 14.0002 16.333C16.3554 16.333 18.6692 16.9528 20.709 18.1302C22.7488 19.3075 24.4429 21.0009 25.621 23.0403C25.9433 23.5982 25.7523 24.3118 25.1944 24.6341C24.6365 24.9564 23.9229 24.7654 23.6006 24.2075C22.6273 22.5227 21.2277 21.1237 19.5426 20.1511C17.8574 19.1784 15.9459 18.6664 14.0002 18.6663Z",
      fill: "#0A072D"
    }, null, -1)
  ])))
}
export default { render: render }